import CircularProgress from '@mui/material/CircularProgress';
import { useEffect, useRef } from "react";

/**
 * Implements a lazy-loading-list of the specified children.
 * @param {*} param0 
 * @returns 
 */
export default function LazyLoader({ onLoad, loading, endReached, children }) {
  // references the element, that when appearing in the viewport, triggers a reload
  const loaderRef = useRef(null);

  /**
   * Updates the observer.
   */
  useEffect(() => {
    if (endReached) return;
    const observer = new IntersectionObserver(entries => {
      let found = false;
      entries.forEach(entry => {
        if (found) return;
        if (entry.isIntersecting && !loading) {
          found = true;
          onLoad();
        }
      });
    }, { threshold: 0.4 });

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }
    return () => observer.disconnect();
  }, [loading, endReached]);

  return (
    <div style={{ position: 'relative' }} >
      <div>
        {children}
      </div>
      {!endReached && <div style={{
        height: 'min(50vh, 20%)',
        width: '400px',
        position: 'absolute',
        bottom: '0vh'
      }} ref={loaderRef} >
      </div>}
      <div style={{
        height: "200px",
        marginTop: '5px',
        background: "transparent",
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      }} >
        {!endReached && <CircularProgress />}
      </div>
    </div>
  );
};